import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import Helmet from 'react-helmet';
import Tooltip from 'rc-tooltip';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import Rule from "./Rule";
import uuidV4 from 'uuid/v4';
import Notification from '../../components/Notification';
import UpgradeRequired from "../../components/UpgradeRequired";
import AudiencePicker from "../../components/AudiencePicker";

class SegmentsNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name:'',
            isLoading:true,
            isError:false,
            segment:{},
            rules:[],
            errors:{},
        }

        this.renderTimeline = this.renderTimeline.bind(this);
        this.renderAddCondition = this.renderAddCondition.bind(this);
        this.handleRuleChange = this.handleRuleChange.bind(this);
        this.newCondition = this.newCondition.bind(this);
        this.handleRuleRemove = this.handleRuleRemove.bind(this);
        this.save = this.save.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleRuleError = this.handleRuleError.bind(this);
        this.changeSegmentProp = this.changeSegmentProp.bind(this);
        this.hasFacebook = this.hasFacebook.bind(this);
    }

    hasFacebook() {
        return this.props.general.apps.filter(item => {
            return item.key == 'FacebookAds';
        }).length > 0;
    }

    changeSegmentProp(key,value) {
        this.setState({
           segment:{
               ...this.state.segment,[key]:value
           }
        });
    }

    handleRuleError(isError,id,value) {
        let errors = {...this.state.errors};

        if(isError) {
            errors[id] = value;
        }else{
            delete errors[id];
        }

        this.setState({errors});

    }

    save() {
        if(this.state.name == '') {
            Notification.error('You need to give this segment a name.');
            return false;
        }

        if(this.state.rules.length <= 0) {
            Notification.error('Not worth saving a segment without conditions..');
            return false;
        }

        let errors = {
            ...this.state.errors
        }

        for(let i in this.state.rules) {
            if(this.refs[this.state.rules[i].id].validate()) {
                if(errors[this.state.rules[i].id]) {
                    delete errors[this.state.rules[i].id];
                }
            }

            this.setState({errors});
        }


        if(Object.keys(errors).length > 0) {
            Notification.error('Please correct rules with errors before saving');
            return false;
        }

        this.setState({
           isLoading:true,
        });

        let method = 'post';
        let url = '/segments';

        if(this.props.segmentId) {
            method = 'put';
            url += '/'+this.props.segmentId;
        }

        let rules = [];

        this.state.rules.map(rule => {
           if(typeof rule.value === 'object') {
               let values = [];
               for(let i in rule.value) {
                   if(rule.key == 'BoughtManufacturer') {
                       values.push(rule.value[i].manufacturer);
                   }else{
                       values.push(rule.value[i].id);
                   }

               }
               rule.value = values.join(',');
           }
            rules.push(rule);
        });


        let data = {
            'name':this.state.name,
            'rules':rules,
            'exportable':this.props.exportable,
            'remove_on_interaction':this.state.segment.remove_on_interaction,
            'audience_id':this.state.segment.audience_id
        }

        if(this.props.type) {
            data.type = this.props.type;
        }

        axios[method](url,data).then(res => {
            Notification.success('Segment saved');
            this.setState({
                isLoading:false,
            })

            this.props.handleSave(res.data);
            this.props.onClose();
        });


    }

    handleRuleRemove(id) {
        let s = this.state.rules.filter(rule => rule.id !== id);

        let errors = {...this.state.errors};

        delete errors[id];


        this.setState({
            rules:s,
            errors:errors
        });
    }

    newCondition() {
        let s = this.state.rules.slice();

        s.push({
            'id':uuidV4(),
            'segment_id':uuidV4(),
            'key':'OrderCount',
            'operator':'==',
            'value':false,
            'use_limit':false,
            'is_and':false,
            'from':null,
            'to':null,
            'use_relative':false,
            'relative':30,
            'limit':30,
        })

        this.setState({
            rules:s
        });
    }

    handleRuleChange(index,key,value) {
        let s = this.state.rules.slice();

        if(s[index].key != key && key == 'key') {
            s[index].value = false;
            s[index].operator = false;
        }

        s[index][key] = value;
        this.setState({
           rules:s
        });
    }

    renderAddCondition() {
       return (
           <li className="timeline-item timeline-reverse timeline-add">
               <div className="timeline-dot bg-blue-grey-600">
                   <i className="icon wb-plus" aria-hidden="true"></i>
               </div>
               <button className="btn btn-dark" onClick={this.newCondition}>New condition</button>
           </li>
       )
    }

    renderTimeline() {
        let rules = [];

        this.state.rules.map((rule,i) => {
            rules.push(
                <Rule exportable={this.props.exportable} ref={rule.id} rules={this.state.rules} handleRuleError={this.handleRuleError} remove={this.handleRuleRemove} segment={this.state.segment} segmentId={this.props.segmentId} handleRuleChange={this.handleRuleChange} index={i} key={rule.id} rule={rule} />
            );

            if((i+1) < this.state.rules.length) {
                rules.push(
                    <li key={`${i}-and`} className="timeline-item timeline-reverse timeline-and">
                        <div className="timeline-dot bg-blue-grey-600">
                            AND
                        </div>
                        <div className="timeline-content"><div className="card card-article">
                            <div className="card-block"></div></div></div>
                    </li>

                );
            }
            

        });

        return rules;
    }


    componentWillMount() {
        if(!this.props.segmentId) {
            this.setState({'isLoading':false});
            return true;
        }
        axios.get(`/segments/${this.props.segmentId}`)
            .then(res => {
                res.data.rules = res.data.rules.map(r => {
                    return {
                        ...r,
                        value:(r.value === '' || !r.value ? false:r.value)
                    }
                });
                this.setState({
                    'isLoading':false,
                    segment:res.data,
                    rules:res.data.rules,
                    name:res.data.name,
                });
            })
            .catch(res => {
                this.setState({'isError':'Segment not found'});
            });
    }



    handleNameChange(e) {
        this.setState({
           name:e.target.value,
        });
    }

    render() {

        if(this.state.isLoading) {
            return (
                <Loading error={this.state.isError} />
            );
        }

        return (
            <div className="overview m-t-30 col-sm-8 offset-sm-2 text-center">
                <h1>Segment</h1>
                <h2>This will create a exportable segment you can import to any ESP.</h2>
                <div className="m-t-40 col-sm-12">
                    <div className="m-b-20 strike">
                        <span>Description</span>
                    </div>
                    <div className="col-sm-12 p-0 offset-sm-0">
                        <input type="text" onChange={this.handleNameChange} className="form-control form-control-lg" value={this.state.name} placeholder="Explain what this segment does.." />
                    </div>
                </div>

                <div className="m-t-40 col-sm-12">
                    <div className="m-b-20 strike">
                        <span>Conditions</span>
                    </div>
                    <div className="col-sm-12 p-0 ">

                        <ul className="timeline timeline-icon">
                            {this.state.rules.length > 0 ?
                                this.renderTimeline()
                            :
                                null
                            }
                            {this.renderAddCondition()}
                        </ul>

                    </div>
                </div>
                {
                    (typeof this.props.exportable === 'undefined' || this.props.exportable == '0') && this.hasFacebook() ?
                        <div className="col-sm-12 m-t-40 m-b-40 offset-sm-0">
                            <div className="m-b-20 strike">
                                <span>Sync segment to a Custom Facebook Audience</span>
                            </div>
                            <AudiencePicker change={this.changeSegmentProp} segment={this.state.segment} />
                        </div>
                        :null
                }


                <div className="col-sm-12 m-t-40 m-b-40 offset-sm-0">
                    {
                        this.props.enabled == '0' ? <UpgradeRequired message="If you want to enable segments, you need to upgrade your account to a larger package" />
                            :
                        <button type="button" onClick={this.save} className="btn btn-dark btn-block">Save</button>
                    }
                </div>



            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth,
        general:state.general,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({},dispatch)
}


SegmentsNew = connect(mapStateToProps,mapDispatchToProps)(SegmentsNew);
export default SegmentsNew;


// WEBPACK FOOTER //
// ./containers/segments/SegmentsNew.js